import React from 'react'
import { Code, Text } from '@mantine/core'

type Props = {
    label: string
    value?: string
    code?: boolean
    valueColor?: string
    onValueClick?: () => void
}

export const Detail = ({ label, value, code, valueColor = 'dark', onValueClick = () => undefined }: Props) => {
    if (!value) return
    if (code) return (
        <>
            <Text>{label}:</Text>
            <Code block style={{ fontSize: 12 }}>{JSON.stringify(value, null, 2)}</Code>
        </>
    )
    return (
        <Text>{label}: {' '}
            <Text span c={valueColor} onClick={valueColor === 'blue' ? () => onValueClick() : () => undefined} style={{ cursor: valueColor === 'blue' ? 'pointer' : 'default' }}>{value}</Text>
        </Text>
    )
}